import { useSuspenseQuery } from '@apollo/client/react';
import { Spinner } from '@chakra-ui/react';
import { Suspense, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { PageContentRoot } from '#components/page-content-root';
import { GET_DOCUMENT_BY_PATH } from '#graphql/queries/document';
import { useAppConfig } from '#providers/app-config-provider';
import { useCurrentUser } from '#providers/user-provider';
import { getDocumentPathFromFilesSplat } from '#utils/document-app-path';

import { DocumentFilesPage } from './document-files-page';

function FilesRouteWithData({ documentPath }: { documentPath: string }) {
  const { config } = useAppConfig();
  const user = useCurrentUser();
  const { data } = useSuspenseQuery(GET_DOCUMENT_BY_PATH, {
    variables: { path: documentPath },
  });
  const result = data?.documentByPath;

  return (
    <DocumentFilesPage
      documentResult={result}
      requestedPath={documentPath}
      apiHost={config.apiHost}
      userEmail={user.email}
    />
  );
}

export function DocumentDFilesRoute() {
  const params = useParams();
  const pathFromUrl = getDocumentPathFromFilesSplat(
    (params as Record<string, string | undefined>)['*'],
  );
  const canRender = useMemo(() => pathFromUrl.length > 0, [pathFromUrl]);

  if (!canRender) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <PageContentRoot
          flex={1}
          alignSelf="stretch"
          display="flex"
          alignItems="center"
          justifyContent="center"
          minH={0}
        >
          <Spinner size="xl" />
        </PageContentRoot>
      }
    >
      <FilesRouteWithData documentPath={pathFromUrl} />
    </Suspense>
  );
}
